import unionBy from 'lodash/unionBy';

import { ILocation } from 'src/types/Location';
import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';

export interface TransformToOptionsParams {
  locations: ILocation[];
}

export interface CombineLocationsParams {
  resultsList: ILocation[];
  fetchedLocation: ILocation | null;
  hasSearchQuery: boolean;
}

export const transformToOptions = ({
  locations,
}: TransformToOptionsParams): DropdownOptionProps[] =>
  locations.map(({ id: value, name: text }) => ({
    value,
    text,
  }));

export const combineLocations = ({
  resultsList,
  fetchedLocation,
  hasSearchQuery,
}: CombineLocationsParams): ILocation[] => {
  const fetchedLocations =
    hasSearchQuery || !fetchedLocation ? [] : [fetchedLocation];
  return unionBy(resultsList, fetchedLocations, 'id');
};
